export const cssUiSchema = {
  type: "Group",
  label: "Styling"
};
